module.exports = __webpack_public_path__ + "a2011605757c3ae98d5e258f7c6888c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-420.jpg
// module id = 429
// module chunks = 0